import React from 'react';
import motiveImg from '../assets/motiveImage.png';
import { BiSolidBuildings } from "react-icons/bi";

const Motive = () => {
  return (
    <div id="motive" className="w-full min-h-screen bg-[#faf1f1] relative px-4 md:px-8 py-4 overflow-hidden">
      <div className="max-w-[1440px] mx-auto flex flex-col xl:flex-row justify-between items-start">
        {/* Content wrapper to control order on different screen sizes */}
        <div className="flex flex-col xl:flex-row justify-between items-start w-full">
          {/* Left Section */}
          <div className="w-full xl:w-[608px] relative order-1">
            {/* "What we do" with line */}
            <div className="flex items-center gap-4 mb-8 mt-8">
              <div className="w-12 h-[2px] bg-black"></div>
              <span className="text-4xl font-extrabold font-roboto">हमारा उद्देश्य</span>
            </div>
            {/* Action Items with left border */}
            <div className="w-full xl:w-[644px] h-auto ml-7 relative">
              <div className="absolute left-0 top-0 bottom-0 w-[2px] bg-gray-200"></div>
              <div className="pl-8 space-y-2">
                {/* Individual Action Items */}
                <div className="flex items-center gap-4 group cursor-pointer h-16 transition-transform transform hover:scale-105">
                  <div className="flex items-center justify-center bg-[#B50301] rounded-lg group-hover:bg-green-200 transition-colors">
                    <BiSolidBuildings className="text-white w-7 h-7" />
                  </div>
                  <div>
                    <h3 className="mb-0 font-extrabold text-gray-800">
                      संविधान में आरक्षण की व्यवस्था की रक्षा करना
                    </h3>
                  </div>
                </div>

                <div className="flex flex-col gap-4 group cursor-pointer h-auto transition-transform transform hover:scale-105">
  <div className="flex items-center justify-start gap-4">
    <div className="flex items-center justify-center bg-[#B50301] rounded-lg group-hover:bg-green-200 transition-colors">
      <BiSolidBuildings className="text-white w-7 h-7" />
    </div>
    <div className="flex-1">
      <h3 className="mb-2 font-extrabold text-gray-800 text-sm sm:text-base break-words">
        बाबा साहब भीम राव अम्बेडकर के द्वारा संविधान में की गयी आरक्षण की व्यवस्था को सही मायने में लागू करवाना
      </h3>
    </div>
  </div>
</div>

<div className="flex flex-col gap-4 group cursor-pointer h-auto transition-transform transform hover:scale-105">
  <div className="flex items-center justify-start gap-4">
    <div className="flex items-center justify-center bg-[#B50301] rounded-lg group-hover:bg-green-200 transition-colors">
      <BiSolidBuildings className="text-white w-7 h-7" />
    </div>
    <div className="flex-1">
      <h3 className="mb-2 font-extrabold text-gray-800 text-sm sm:text-base break-words">
        कोई भी व्यक्ति एक बार आरक्षण के तहत कोई नौकरी या जनप्रतिनिधि के रूप में चुन लिया जाता है, तो उसके परिवार को क्रीमी लेयर के तहत आरक्षित जाती से बाहर करना, जिससे किसी दुसरे परिवार को मौका मिले
      </h3>
    </div>
  </div>
</div>


                <div className="flex items-center gap-4 group cursor-pointer h-16 transition-transform transform hover:scale-105">
                  <div className="flex items-center justify-center bg-[#B50301] rounded-lg group-hover:bg-green-200 transition-colors">
                    <BiSolidBuildings className="text-white w-7 h-7" />
                  </div>
                  <div>
                    <h3 className="mb-0 font-extrabold text-gray-800">
                      नारा लगाने वालों के स्थान पर नेतृत्व करने वाला बनाना
                    </h3>
                  </div>
                </div>

                <div className="flex items-center gap-4 group cursor-pointer h-16 transition-transform transform hover:scale-105">
                  <div className="flex items-center justify-center bg-[#B50301] rounded-lg group-hover:bg-green-200 transition-colors">
                    <BiSolidBuildings className="text-white w-7 h-7" />
                  </div>
                  <div>
                    <h3 className="mb-0 font-extrabold text-gray-800">
                      राष्ट्रिय एकता और अखंडता हेतु कार्य करना
                    </h3>
                  </div>
                </div>

                <div className="flex items-center gap-4 group cursor-pointer h-16 transition-transform transform hover:scale-105">
                  <div className="flex items-center justify-center bg-[#B50301] rounded-lg group-hover:bg-green-200 transition-colors">
                    <BiSolidBuildings className="text-white w-7 h-7" />
                  </div>
                  <div>
                    <h3 className="mb-0 font-extrabold text-gray-800">
                      वृहद् समाज का सहयोग लेना
                    </h3>
                  </div>
                </div>

                <div className="flex items-center gap-4 group cursor-pointer h-16 transition-transform transform hover:scale-105">
                  <div className="flex items-center justify-center bg-[#B50301] rounded-lg group-hover:bg-green-200 transition-colors">
                    <BiSolidBuildings className="text-white w-7 h-7" />
                  </div>
                  <div>
                    <h3 className="mb-0 font-extrabold text-gray-800">
                      सामाजिक संघर्ष के स्थान पर सामाजिक समरसता और सामाजिक सामंजस्य स्थापित करना
                    </h3>
                  </div>
                </div>

                <div className="flex items-center gap-4 group cursor-pointer h-16 transition-transform transform hover:scale-105">
                  <div className="flex items-center justify-center bg-[#B50301] rounded-lg group-hover:bg-green-200 transition-colors">
                    <BiSolidBuildings className="text-white w-7 h-7" />
                  </div>
                  <div>
                    <h3 className="mb-0 font-extrabold text-gray-800">
                      शिक्षा, स्वास्थ्य, रोजगार, जन जागरण और परंपराओं के संरक्षण हेतु कार्य करना
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Section - Image */}
          <div className="w-full xl:w-[644px] h-auto relative mt-8 xl:mt-24 flex flex-col items-center xl:items-end order-2">
            <img 
              src={motiveImg}  
              alt="What we do illustration"
              className="w-[250px] sm:w-[300px] md:w-[400px] xl:w-[644px] h-auto object-cover transition-all duration-300"
            />
            <div className="text-center mt-4">
              <a 
                href="https://prasarbharati.gov.in/whatsnew/whatsnew_653363.pdf" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-red-500 underline hover:text-blue-800"
              >
                डॉ. अम्बेडकर जी का पूरा भाषण पढ़ने के लिए क्लिक करें - CAD, Vol. XI, 25 नवंबर 1949
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Motive;
